
<div class="row">
  <div class="col-md-5 col-sm-12 col-12">
    <mat-button-toggle-group class="w-100" style="border: none" (change)="changeButtons($event)" name="favoriteColor"
      aria-label="Favorite Color" [hideSingleSelectionIndicator]="true" [value]="currentTab">
      @for( button of buttonDetails;track $index){
      <mat-button-toggle class="sage-button-group" value="{{ button.buttonValue }}">{{ button.buttonName | translate
        }}</mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>

  <div class="col-md-3 col-sm-12 col-12"></div>

  @if(enabledDatePicker){
  <div class="col-md-4 col-sm-12 col-12">
    <div class="row">
      <div class="col-md-6 col-sm-12 col-12">
        <div class="d-flex flex-column">
          <mat-label class="datepicker-label">{{'ticketHistory.startDate' | translate }}</mat-label>
          <mat-form-field class="custom-form-width" appearance="outline">
            <input #startDateInput matInput [matDatepicker]="pickerstart" [(ngModel)]="startDate"
               (dateChange)="onStartDateChange($event.value)"
              [matDatepickerFilter]="startDateFilter"  [max]="today"/>
            <mat-datepicker-toggle matIconSuffix [for]="pickerstart" (click)="pickerstart.open()"
            >
            </mat-datepicker-toggle>
            <mat-datepicker #pickerstart></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-12">
        <div class="d-flex flex-column">
          <mat-label class="datepicker-label">{{'ticketHistory.endDate' | translate }}</mat-label>
          <mat-form-field class="custom-form-width" appearance="outline">
            <input #endDateInput matInput [matDatepicker]="pickerend" [(ngModel)]="endDate" 
              (dateChange)="onEndDateChange($event.value)" [matDatepickerFilter]="endDateFilter"
              [max]="today" />
            <mat-datepicker-toggle matIconSuffix [for]="pickerend" (click)="pickerend.open()">
            </mat-datepicker-toggle>
            <mat-datepicker #pickerend></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12">
        <div *ngIf="dateErrorKey" class="text-danger mt-1">{{ dateErrorKey | translate }}</div>
      </div>
    </div>
  </div>
  }
</div>
<div class="row">
  <div class="col-md-12 col-sm-12">
    <div class="ticket-history-grid table-responsive">
      <table mat-table [dataSource]="dataSource.data" matSort (matSortChange)="sortData($event)"
        class="mat-elevation-z8">
        @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.columnDef">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="column.sortable" mat-sort-header="{{ column.columnDef }}">
              {{ column.header | translate}}
            </span>
            <span *ngIf="!column.sortable">
              {{ column.header | translate}}
            </span>
          </th>
          <td mat-cell class="truncate-cell" [title]="column.cell(row, i)" *matCellDef="let row; let i = index">
            @if(column.clickable){
            <span class="highlight cursor" tabindex="0" (keydown.enter)="redirectEntity(row)"
              (click)="redirectEntity(row)">{{ row.CaseNumber }}</span>
            } @else if(column.checkbox){
            <!-- <mat-checkbox [checked]="row.CCARD_ID._text === selectedCardId" [disabled]="true"
              ></mat-checkbox> -->
                <mat-radio-button [value]="row" [checked]="row.CCARD_ID._text === selectedCardId"
                [disabled]="row.isExpiredCard"
                  (change)="defaultCardSelection(row)">
            </mat-radio-button>
            } @else if(column.action){
            <!-- <mat-icon class="cursor" (click)="actionButtonClick(row)">delete</mat-icon> -->
             <img src="/images/delete.svg" alt="back" width="24px"
                    height="24px" class="cursor" (click)="actionButtonClick(row)"
                    (keydown.enter)="actionButtonClick(row)" tabindex="1">
            } @else if(column.clickableStatus){
            <span [ngClass]="row.isExpiredCard?'expired cursor':'highlight cursor'"
            class="d-flex gap-2" tabindex="1" (keydown.enter)="prepopulateCreditCardDetails(row)"
              (click)="prepopulateCreditCardDetails(row)">
              {{ row.status }}
              @if(row.isExpiredCard){
                <img src="/images/red-warning.svg" class="warning" alt="expired" width="24px"
                height="24px">
              }
            </span>
            }@else if(column.radioButton) {
            <mat-radio-button [value]="row" [checked]="row.selection"  (change)="onSelectedRow(row)">
            </mat-radio-button>
            }@else if(column.isEdit) {
            <span class="edit" [hidden]="row.primaryContact" tabindex="0" (keydown.enter)="redirectEntity(row)"
              (click)="redirectEntity(row)">{{ column.cell(row,
              i) }}</span>
            }
            @else if(column.columnDef==='index') {
            {{this.currentPage * this.pageSize + (i ?? 0) + 1}}
            }
            @else if(column.noHyperlinkText){
            <span class="highlight cursor-none">{{ row.servicePlan }}</span>
             }
             @else if(column.creditCardType){
                 <img src="/images/{{row.CARD_TYPE._text}}.svg" alt="{{row.CARD_TYPE}}" width="32px"
                    height="32px" class="cursor">
             }
             @else if(column.mask){
              ***{{column.cell(row,i)}}
             }
            @else {
            {{ column.cell(row, i) }}
            }
          </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell nodata" [attr.colspan]="displayedColumns.length" style="text-align: center">
            {{'common.noResultsFound' |translate}}
          </td>
        </tr>
      </table>
      @if(totalItems>pageSize){

      <div class="pagination-controls">
        <button (click)="setPage(0)" [disabled]="currentPage === 0">
           {{'common.first' | translate}}
        </button>
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 0">
          {{'common.previous' | translate}}
        </button>

        <span>{{'common.page' | translate}} {{ currentPage + 1 }} of {{ totalPages }}</span>

        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage >= totalPages - 1">
          {{'common.next' | translate}}
        </button>
        <button (click)="setPage(totalPages - 1)" [disabled]="currentPage >= totalPages - 1">
          {{'common.last' | translate}}
        </button>
      </div>
      }
    </div>
  </div>
</div>
